/**
 * Helpers for Concordium WalletConnect session validation.
 */

import { CCD_NAMESPACE, CCD_CHAIN_ID } from "./ccdConstants.js";

const GENERIC_NAMESPACE = "generic";
const CCD_CAIP_CHAIN = `${CCD_NAMESPACE}:${CCD_CHAIN_ID}`;

export function isEvmStyleAddress(address) {
  if (!address || typeof address !== "string") {
    return false;
  }
  return address.startsWith("0x");
}

export function isLikelyConcordiumAddress(address) {
  if (!address || typeof address !== "string") {
    return false;
  }
  if (isEvmStyleAddress(address)) {
    return false;
  }
  return /^[1-9A-HJ-NP-Za-km-z]{50}$/.test(address);
}

export function sessionNamespaces(provider) {
  return provider?.session?.namespaces || null;
}

export function sessionHasCcdNamespace(provider) {
  const namespaces = sessionNamespaces(provider);
  if (!namespaces) {
    return false;
  }
  const ccd = namespaces[CCD_NAMESPACE];
  if (!ccd) {
    return false;
  }
  const chains = ccd.chains || [];
  const accounts = ccd.accounts || [];
  return chains.length > 0 || accounts.length > 0;
}

export function sessionIsGenericOnly(provider) {
  const namespaces = sessionNamespaces(provider);
  if (!namespaces) {
    return false;
  }
  return (
    Boolean(namespaces[GENERIC_NAMESPACE]) && !sessionHasCcdNamespace(provider)
  );
}

export function sessionSupportsCcdChain(provider, chainId = CCD_CAIP_CHAIN) {
  if (!sessionHasCcdNamespace(provider)) {
    return false;
  }
  const namespaces = sessionNamespaces(provider);
  const ccd = namespaces[CCD_NAMESPACE];
  const chains = new Set([
    ...(ccd.chains || []),
    ...(ccd.accounts || [])
      .map((account) => {
        const parts = account.split(":");
        return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : null;
      })
      .filter(Boolean),
  ]);
  return chains.has(chainId);
}
